<template>
  <!-- 公共服务平台框架 -->
  <el-container class="mainPage">
    <div class="mainPage-left">
      <leftnav></leftnav>
    </div>
    <div class="mainPage-right">
      <navcon></navcon>
      <div class="mainBox">
        <router-view></router-view>
      </div>
    </div>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../components/navcon.vue';
import leftnav from '../components/leftnav.vue';
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      showtype: false
    };
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {},
  created() {
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow';
      } else {
        setTimeout(() => {
          this.showclass = 'aside';
        }, 300);
      }
    });
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    // this.$message({
    //   message: '登录成功',
    //   type: 'success'
    // })
  }
};
</script>
<style lang="scss">
@import '../assets/scss/index.scss';
.mainPage {
  width: 100%;
  height: 100vh;
  display: flex;
  // overflow: hidden;
  &-left {
    width: 200px;
    height: 100%;
  }
  &-right {
    flex: 1;
    background: $backColorF5;
    overflow: hidden;
    .mainBox {
      height: calc(100vh - 60px);
      padding: 0 20px;
    }
  }
}

// 更改菜单之前的样式

.viewOpen {
  height: 520px;
  background: red;
}
.backVideo {
  color: #1268cc;
  font-size: 14px;
  cursor: pointer;
}

.el-main {
  background: #f7f7f7;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clear,
.layui-clear {
  clear: both;
}

.over_h {
  overflow: hidden;
}

.dis_n {
  display: none;
}

.el-form-item {
  float: left;
  margin-right: 15px;
  margin-bottom: 15px;
}

.el-form {
  overflow: hidden;
}

ul,
li {
  list-style: none;
  padding: 0;
}

.cursor {
  cursor: pointer;
}

.ele-box {
  background: #fff;
  padding: 10px 20px;
}

.fixedTop .items {
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 20px;
}

.botCont {
  margin-top: 0px;
}

.borderBtn {
  background-color: #fff;
  color: #30bf30;
}

.noneBorder {
  color: #666;
  border-color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/views/index.vue